import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';

export default defineNuxtPlugin(() => {
  const DSPCounterUrl = 'https://tags.soloway.ru/DSPCounter.min.js';
  const globalStore = useGlobalStore();
  const interactiveStore = useInteractiveStore();
  if (interactiveStore.isPageSpeedBot) return;

  function init() {
    (function (w: any, d, n, u, s) {
      w[n] =
        w[n] ||
        function () {
          // eslint-disable-next-line prefer-rest-params
          (w[n].q = w[n].q || []).push(arguments);
        };
      const a: any = d.createElement(s);
      const m: any = d.getElementsByTagName(s)[0];
      a.async = true;
      a.src = u;
      m.parentNode.insertBefore(a, m);
      if (window && 'DSPCounter' in window) {
        window.DSPCounter('firstSend', { sid: 224071 });
      }
    })(window, document, 'DSPCounter', DSPCounterUrl, 'script');
  }

  const runtimeConfig = useRuntimeConfig();
  const isProd = runtimeConfig.public.isProd;
  if (isProd && !globalStore.webview) {
    interactiveStore.addFunction(init);
  }
});
